import { classNames } from 'primereact/utils'

const TRANSITIONS = {
    overlay: {
        timeout: 150,
        classNames: {
            enter: 'opacity-0 scale-75',
            enterActive:
                'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
            exit: 'opacity-100',
            exitActive:
                '!opacity-0 transition-opacity duration-150 ease-linear',
        },
    },
}

const calendar = {
    root: ({ props }: { props: any }) => ({
        className: classNames(
            // Display and Position
            'inline-flex',
            'max-w-full',
            // 'relative',
            // Misc
            {
                'opacity-60 select-none pointer-events-none cursor-default':
                    props.disabled,
            }
        ),
    }),
    input: ({ props }: { props: any }) => ({
        root: {
            className: classNames(
                // Display
                'flex flex-auto',
                // Font
                'leading-none',
                'w-full',
                // Colors
                'text-surface-600',
                'placeholder:text-surface-400 ',
                'bg-surface-0',
                'border border-solid',
                { 'border-grey-5': !props.invalid },
                // Invalid State
                { 'border-red-500': props.invalid },
                // Spacing
                'm-0 p-3',
                // Shape
                'appearance-none',
                {
                    'rounded-md':
                        !props.showIcon || props.iconDisplay === 'input',
                },
                {
                    'rounded-l-md  flex-1 pr-9':
                        props.showIcon && props.iconDisplay !== 'input',
                },
                {
                    'rounded-md flex-1 pr-9':
                        props.showIcon && props.iconDisplay === 'input',
                },
                // Transitions
                'transition-colors',
                'duration-200',
                // States
                { 'hover:border-primary-hover': !props.invalid },
                'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-500/50'
            ),
        },
    }),
    inputicon: {
        className: classNames(
            'absolute top-[50%] -mt-2',
            'text-surface-600',
            'right-[.75rem]'
        ),
    },
    dropdownButton: {
        root: {
            className: classNames(
                'relative',
                'items-center inline-flex text-center align-bottom',
                'rounded-r-md',
                'px-4 py-3 leading-none',
                'text-primary-inverse',
                'bg-primary',
                'border border-primary',
                'focus:outline-none focus:outline-offset-0 focus:ring',
                'hover:bg-primary-hover hover:border-primary-hover',
                'focus:ring-primary-400/50'
            ),
        },
    },
    panel: ({ props }: { props: any }) => ({
        className: classNames(
            // Display & Position
            {
                absolute: !props.inline,
                'inline-block': props.inline,
            },
            // Size
            '!min-w-0',
            '!w-full',
            'max-w-[408px]',

            // Shape
            'rounded-lg',
            'border-solid border border-grey-6',
            { 'shadow-md': !props.inline },
            // Colors
            'bg-white',
            'border-surface-200',
            //misc
            { 'overflow-x-auto': props.inline }
        ),
    }),
    datepickerMask: {
        className: classNames(
            'fixed top-0 left-0 w-full h-full',
            'flex items-center justify-center',
            'bg-black bg-opacity-90'
        ),
    },
    header: {
        className: classNames(
            'font-semibold p-2',
            'flex items-center justify-between',
            'm-0',
            'border-b',
            'rounded-t-md',
            'border-0 border-b border-solid border-grey-6'
        ),
    },
    previousbutton: {
        className: classNames(
            'relative',
            'inline-flex items-center justify-center',
            'w-8 h-8',
            'p-0 m-0',
            'rounded-full',
            'text-allstate-navy',
            'border border-allstate-light-blue border-solid',
            'bg-transparent',
            'transition-colors duration-200 ease-in-out',
            'hover:text-surface-700',
            'hover:bg-surface-100',
            'cursor-pointer overflow-hidden'
        ),
    },
    title: {
        className: classNames(
            'font-bold',
            'bg-transparent border-0',
            'text-allstate-blue',
            'transition duration-200',
            'p-2',
            'm-0',
            'cursor-pointer'
        ),
    },
    monthTitle: {
        className: classNames(
            'font-bold',
            'bg-transparent border-0',
            'text-allstate-blue',
            'transition duration-200',
            'p-2',
            'm-0',
            'cursor-pointer'
        ),
    },
    yearTitle: {
        className: classNames(
            'font-bold',
            'bg-transparent border-0',
            'text-allstate-blue',
            'transition duration-200',
            'p-2',
            'm-0',
            'cursor-pointer'
        ),
    },
    nextbutton: {
        className: classNames(
            'relative',
            'inline-flex items-center justify-center',
            'w-8 h-8',
            'p-0 m-0',
            'rounded-full',
            'text-surface-600 ',
            'border border-faded-blue border-solid',
            'bg-transparent',
            'transition-colors duration-200 ease-in-out',
            'hover:text-surface-700',
            'hover:bg-surface-100',
            'cursor-pointer overflow-hidden'
        ),
    },
    table: {
        className: classNames(
            'text-base leading-none',
            'border-collapse',
            'w-full',
            'm-0 my-2'
        ),
    },
    tableheadercell: { className: classNames('p-0 md:p-2') },
    weekheader: {
        className: classNames(
            'leading-[normal]',
            'text-surface-600',
            'opacity-60 cursor-default'
        ),
    },
    weeknumber: {
        className: classNames('text-surface-600', 'opacity-60 cursor-default'),
    },
    weekday: { className: classNames('text-surface-500') },
    day: { className: classNames('p-0 md:p-2') },
    weeklabelcontainer: ({ context }: { context: any }) => ({
        className: classNames(
            // Flexbox and Alignment
            'flex items-center justify-center',
            'mx-auto',
            // Shape & Size
            'w-10 h-10',
            'rounded-full',
            'border-transparent border',
            // Colors
            {
                'text-surface-600 bg-transparent':
                    !context.selected && !context.disabled,
                'text-primary-highlight-inverse bg-primary-highlight':
                    context.selected && !context.disabled,
            },
            // States
            'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-400/50',
            {
                'hover:bg-surface-100': !context.selected && !context.disabled,
                'hover:bg-primary-highlight-hover':
                    context.selected && !context.disabled,
            },
            {
                'opacity-60 cursor-default': context.disabled,
                'cursor-pointer': !context.disabled,
            }
        ),
    }),
    daylabel: ({ context }: { context: any }) => ({
        className: classNames(
            // Flexbox and Alignment
            'flex items-center justify-center',
            'mx-auto',
            'text-allstate-navy',
            // Shape & Size
            'w-10 h-10',
            'rounded-full',
            'border-transparent border',
            // Colors
            {
                'bg-white border border-solid border-allstate-navy':
                    context.today,
                'bg-allstate-blue text-white':
                    context.selected && !context.disabled,
                'opacity-60': context.disabled,
                'bg-faded-blue': context.disabled && context.selected,
                'hover:bg-faded-blue': !context.disabled && !context.selected,
            },

            // cursors
            {
                'cursor-default': context.disabled,
                'cursor-pointer': !context.disabled,
            }
        ),
    }),
    monthpicker: { className: classNames('my-2') },
    month: ({ context }: { context: any }) => ({
        className: classNames(
            // Flexbox and Alignment
            'inline-flex items-center justify-center',
            // Size
            'w-1/3',
            'p-2',
            // Shape
            'rounded-md',
            // Colors
            {
                'bg-allstate-blue text-white':
                    context.selected && !context.disabled,
                'opacity-60': context.disabled,
                'bg-faded-blue': context.disabled && context.selected,
                'hover:bg-faded-blue': !context.disabled && !context.selected,
            },

            // cursors
            {
                'cursor-default': context.disabled,
                'cursor-pointer': !context.disabled,
            }
        ),
    }),
    yearpicker: { className: classNames('my-2') },
    year: ({ context }: { context: any }) => ({
        className: classNames(
            // Flexbox and Alignment
            'inline-flex items-center justify-center',
            // Size
            'w-1/3',
            'p-2',
            // Shape
            'rounded-md',
            // Colors
            {
                'bg-allstate-blue text-white':
                    context.selected && !context.disabled,
                'opacity-60': context.disabled,
                'bg-faded-blue': context.disabled && context.selected,
                'hover:bg-faded-blue': !context.disabled && !context.selected,
            },

            // cursors
            {
                'cursor-default': context.disabled,
                'cursor-pointer': !context.disabled,
            }
        ),
    }),
    timepicker: {
        className: classNames(
            'flex',
            'justify-center items-center',
            'border-t-1',
            'border-solid border-surface-200',
            'p-2'
        ),
    },
    separatorcontainer: {
        className: classNames('flex', 'items-center', 'flex-col', 'px-2'),
    },
    separator: { className: classNames('text-xl') },
    hourpicker: {
        className: classNames('flex', 'items-center', 'flex-col', 'px-2'),
    },
    minutepicker: {
        className: classNames('flex', 'items-center', 'flex-col', 'px-2'),
    },
    secondPicker: {
        className: classNames('flex', 'items-center', 'flex-col', 'px-2'),
    },
    ampmpicker: {
        className: classNames('flex', 'items-center', 'flex-col', 'px-2'),
    },
    incrementbutton: {
        className: classNames(
            'relative',
            'inline-flex items-center justify-center',
            'w-8 h-8',
            'p-0 m-0',
            'rounded-full',
            'text-surface-600',
            'border-0',
            'bg-transparent',
            'transition-colors duration-200 ease-in-out',
            'hover:text-surface-700',
            'hover:bg-surface-100',
            'cursor-pointer overflow-hidden'
        ),
    },
    decrementbutton: {
        className: classNames(
            'relative',
            'inline-flex items-center justify-center',
            'w-8 h-8',
            'p-0 m-0',
            'rounded-full',
            'text-surface-600',
            'border-0',
            'bg-transparent',
            'transition-colors duration-200 ease-in-out',
            'hover:text-surface-700',
            'hover:bg-surface-100',
            'cursor-pointer overflow-hidden'
        ),
    },
    groupcontainer: { className: classNames('flex') },
    group: {
        className: classNames(
            'flex-1',
            'border-l',
            'border-surface-200',
            'pr-0.5',
            'pl-0.5',
            'pt-0',
            'pb-0',
            'first:pl-0',
            'first:border-l-0'
        ),
    },
    buttonbar: {
        className: classNames(
            'flex justify-between items-center',
            'py-3 px-0',
            'border-t border-surface-200'
        ),
    },
    todaybutton: {
        root: {
            className: classNames(
                'inline-flex items-center justify-center',
                'px-4 py-3 leading-none',
                'rounded-md',
                'bg-transparent border-transparent',
                'text-primary',
                'transition-colors duration-200 ease-in-out',
                'focus:outline-none focus:outline-offset-0 focus:ring',
                'hover:bg-primary-300/20',
                'cursor-pointer'
            ),
        },
    },
    clearbutton: {
        root: {
            className: classNames(
                'inline-flex items-center justify-center',
                'px-4 py-3 leading-none',
                'rounded-md',
                'bg-transparent border-transparent',
                'text-primary',
                'transition-colors duration-200 ease-in-out',
                'focus:outline-none focus:outline-offset-0 focus:ring',
                'hover:bg-primary-300/20',
                'cursor-pointer'
            ),
        },
    },
    transition: TRANSITIONS.overlay,
}

export default calendar
